import { render } from "./ChatbotModal.vue?vue&type=template&id=447eccbe"
import script from "./ChatbotModal.vue?vue&type=script&lang=js"
export * from "./ChatbotModal.vue?vue&type=script&lang=js"

import "./ChatbotModal.vue?vue&type=style&index=0&id=447eccbe&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__